import { createSlice } from "@reduxjs/toolkit";
import { getCategoriesFunc, getCategoriesSelectFunc, searchCategoriesFunc, clearSearchCategoriesFunc, addProductFromJSON, clearSubmittedProductFunc } from "./thunk";

export const initialState: any = {
  categories: [],
  form: [],
  searchList: [],
  error: {},
  product: {}
};


const CategorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    clearForm(state) {
      state.form = [];
      state.product = {};
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCategoriesFunc.fulfilled, (state: any, action: any) => {
      for (let item of action?.payload) {
        const catIndex = state.categories.findIndex((x: any) => x._id === item._id);
        if (catIndex === -1) {
          state.categories.push(item);
        }
      }
    });
    builder.addCase(getCategoriesSelectFunc.fulfilled, (state: any, action: any) => {
      state.form = action.payload;
    });
    builder.addCase(searchCategoriesFunc.fulfilled, (state: any, action: any) => {
      state.searchList = action.payload;
      for (let category of action.payload) {
        if (category.childCategoriesByParent) {
          let keys = Object.keys(category.childCategoriesByParent);
          for (let key of keys) {
            for (let item of category.childCategoriesByParent[key]) {
              const catIndex = state.categories.findIndex((x: any) => x._id === item._id);
              if (catIndex === -1) {
                state.categories.push(item);
              }
            }
          }
        }
      }
    });
    builder.addCase(clearSearchCategoriesFunc.fulfilled, (state: any, action: any) => {
      state.searchList = action.payload;
    });
    builder.addCase(addProductFromJSON.fulfilled, (state: any, action: any) => {
      state.product = action.payload;
    });
    builder.addCase(clearSubmittedProductFunc.fulfilled, (state: any, action: any) => {
      state.product = {};
    });
  },
});

export const { clearForm } = CategorySlice.actions;

export default CategorySlice.reducer;
